(function(){
    $(document).ready(function(){
        let $twitterBtn = $('.twitter-share-button');
        let $facebookBtn = $('.fb-like');

        if ($twitterBtn.length > 0) {
            window.twttr = (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0],
                    t = window.twttr || {};
                if (d.getElementById(id)) return t;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js, fjs);

                t._e = [];
                t.ready = function(f) {
                    t._e.push(f);
                };

                return t;
            }(document, "script", "twitter-wjs"));

            var twtUrl = $twitterBtn.first().data('url');

            // Twitter Tweet button tracking
            twttr.ready(function(twttr){
                twttr.events.bind('click', function(){
                    dataLayer.push({
                        'event': 'social',
                        'socialNetwork': 'twitter',
                        'socialAction': 'tweet',
                        'socialTarget': twtUrl
                    });
                });
            });
        }

        if ($facebookBtn.length > 0) {
            window.fbAsyncInit = function() {
                FB.init({
                    appId      : '990097771065446',
                    xfbml      : true,
                    version    : 'v2.5'
                });

                // FB Like buttons tracking
                FB.Event.subscribe('edge.create', function (url) {
                    dataLayer.push({
                        'event': 'social',
                        'socialNetwork': 'facebook',
                        'socialAction': 'like',
                        'socialTarget': url
                    });
                });
            };

            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.async=true;
                js.src = "https://connect.facebook.net/cs_CZ/all.js#xfbml=1";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }

    });
})();


// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/initSocialButtons.js